import styled from "styled-components";
import ArticleList from "../../components/contents/board/ArticleList";
import PageTemplate from "../../components/ui/common/template/PageTemplate";
import CenterDiv from "../../style/styled-components/components/CenterDiv";
import ContentDiv from "../../style/styled-components/components/ContentDiv";
import { useArticles } from "../../components/hooks/useArticles";
const Board1Page = () => {
  const articlelist = useArticles("aonenews");
  return (
    <PageTemplate title="에이원 소식" noImage>
      <CenterDiv>
        <ContentDiv>
          <Div>
            <ArticleList
              category="aonenews"
              contents={articlelist}
            />
          </Div>
        </ContentDiv>
      </CenterDiv>
    </PageTemplate>
  );
};
export default Board1Page;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 2.5rem;
`;
